import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { PagedRequestDto } from '../../paged-request.model';

export interface ContractorsMeUnifiedShiftsParamsDto extends PagedRequestDto {
  stages?: UnifiedShiftStage[];
  startDate?: string; // ISO date string
  endDate?: string; // ISO date string
  facilityId?: string;
  scopesOfPractice?: ScopeOfPracticeEnum[];
  shiftTypes?: number[];
  latitude?: number;
  longitude?: number;
  maxDistanceMiles?: number;
  useContractorSearchRadius?: boolean; // If true, use contractor's profile search radius instead of maxDistanceMiles
  sortByDistance?: boolean; // If true, sort results by distance from provided lat/lng
  minHourlyRate?: number;
  maxHourlyRate?: number;
}

export enum UnifiedShiftStage {
  Need = 'Need',
  Application = 'Application',
  Request = 'Request',
  Confirmed = 'Confirmed',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}
